import { render, staticRenderFns } from "./SectionPatient.vue?vue&type=template&id=5e673c46&scoped=true"
import script from "./SectionPatient.vue?vue&type=script&lang=js"
export * from "./SectionPatient.vue?vue&type=script&lang=js"
import style0 from "./SectionPatient.vue?vue&type=style&index=0&id=5e673c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e673c46",
  null
  
)

export default component.exports